import { StateSchema } from 'app/config/storeConfig/types';

export const getSelectedFloorId = (state: StateSchema): Nullable<string> => state.warehouseMapConstructor.selectedFloorId;
